import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import iconSprite from '../../../assets/icon-sprite.svg';

class TransactionDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps?.data?.id !== this.props?.data?.id) {
      // if needs be, fetch fresh data.
    }
  }

  render() {
    const { visible, onClose = function $() {}, data } = this.props;
    return (
      <Modal className="modal fade" centered show={visible} onHide={onClose}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="linkDetailsLabel">Transaction Details</h5>
            <button type="button" className="close" onClick={onClose}>
              <svg width="48" height="48">
                <use xlinkHref={iconSprite + '#close-icon'}></use>
              </svg>
            </button>
          </div>
          <div className="modal-body">
            <div className="d-flex justify-content-between">
              <p>Type</p>
              <span>{data?.type}</span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Narration</p>
              <span style={{ textAlign: 'right' }}>{data?.description}</span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Amount</p>
              <span>{Number(data?.amount).toLocaleString()}</span>
            </div>
            {/* <div className="d-flex justify-content-between">
              <p>Transaction Fee</p>
              <span>hey</span>
            </div> */}
            <div className="d-flex justify-content-between">
              <p>Date</p>
              <span>{moment(data?.created_on).format('MMM DD, YYYY, h:mm:ss a')}</span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Status</p>
              <span>{data?.status}</span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Reference</p>
              <span style={{ textAlign: 'right' }}>{data?.reference}</span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Transaction Type</p>
              <span style={{ textTransform: 'capitalize' }}>{data?.entry}</span>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default TransactionDetails;
